export const CATALOG_DOCTOR_EMPTY_LABEL = "استاد ثبت نشده";

export function instructorPersonLabel(person) {
	const name = (person?.name ?? "").trim();
	if (name) {
		return name;
	}
	const phone = (person?.phone_number ?? "").trim();
	if (phone) {
		return phone;
	}
	return "";
}

/** @param {{ instructors_detail?: array } | null | undefined} item */
export function resolveCatalogInstructor(item) {
	const instructors = item?.instructors_detail ?? [];
	const labels = instructors.map(instructorPersonLabel).filter(Boolean);

	if (labels.length === 0) {
		return {
			subtitle: CATALOG_DOCTOR_EMPTY_LABEL,
			avatarUrl: undefined,
			isEmpty: true,
		};
	}

	return {
		subtitle: labels.join("، "),
		avatarUrl: instructors[0]?.avatar_url,
		isEmpty: false,
	};
}
